(function() {
	'use strict';
	angular.module('app.setup')
		.controller('configSSOForm', configSSOForm);

	configSSOForm.$inject = ['$scope', 'configSSOService', 'storeService'];
	function configSSOForm($scope, configSSOService, storeService) {
		var vm = this;
		vm.customerNdx = $scope.customerNdx;
		vm.samlProfileId = $scope.samlProfileId;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.allowedDomains = $scope.allowedDomains;
		vm.allowedDomainsReadonly = $scope.allowedDomainsReadonly;
		init();
		
		function init() {
			if (vm.action == 'Edit') {
				configSSOService.getSamlProfile(vm.samlProfileId).then(function (samlProfile) {
					vm.SamlProfile = samlProfile;
					vm.metadataPlain = samlProfile.metadata;
					vm.allowedDomains = samlProfile.allowedDomains;
					vm.dateExpiry = new Date(samlProfile.dateExpiry);
				});
			} 
			
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			vm.SamlProfile.metadata = btoa(vm.metadataPlain);
			vm.SamlProfile.allowedDomains = vm.allowedDomains;
			if (vm.action == 'Edit') {
				configSSOService.updateSamlProfile(vm.SamlProfile, new Date(vm.SamlProfile.dateModified).toUTCString(), vm.samlProfileId).then(function (message) {
					if (_.isString(message)) {
						$scope.result(message, false);
					} else {
						$scope.result('SAML Profile updated successfully', true);
					}
					vm.isSaveButtonDisabled = false;
				});
			} else {
				configSSOService.createSamlProfile(vm.SamlProfile).then(function (message) {
					if (_.isString(message)) {
						$scope.result(message, false);
					} else {
						$scope.result('SAML Profile updated successfully', true);
					}
					vm.isSaveButtonDisabled = false;
				});
			}
		}
		
		function close() {
			$scope.result('', false);
		}
	}
})();
